import { Hamburger } from "../atoms/Hamburger";
import { NavigationItems } from "../atoms/NavigationItems";
import { UploadLink } from "../atoms/UploadLink";
import "animate.css";

import { useState } from "react";

export function NavigationTablet() {
  const [open, setOpen] = useState(false);
  const handleClick = async () => {
    setOpen(!open);
  };
  return (
    <div className="navbar d-flex flex-row align-c vw-50 justify-sb">
      <UploadLink className="" />
      <Hamburger onclick={() => handleClick()} open={open} />
      <NavigationItems
        classes={`nav-mobile z-5 vw-100 align-c pos-a bg-primary pb-s d-flex flex-col animate__animated ${
          open ? "animate__fadeInDown" : "animate__fadeOutUpBig animate__slow"
        }`}
      />
    </div>
  );
}
